<template>
  <ContentBox>
    <template v-slot:tools>
    </template>
    <template v-slot:content>
      <div class="row">
        <div class="col-lg-12">
          <div v-if="userHasUpdatePermission(PermissionTypes.PricingPermissionTypes.pricingConfig) && !priceListConfig.editing" style="clear: both;">
            <ActionDropMenu class="float-right">
              <DropdownMenuItem @click="priceListConfig.editing=true" icon="fa-pencil">Edit Price List Config</DropdownMenuItem>
            </ActionDropMenu>
          </div>
          <h3>Customer Price List Configuration</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <FormGroup :form="priceListConfig.editorForm">

            <PriceListConfigEditor 
              :isCustomer="true"
              :config="priceListConfig.configData"
              :stockPriceGroupList="stockPriceGroupList"
              :editing="priceListConfig.editing"
              @update="priceListConfig.configData = $event"
              @updateOptions="priceListConfig.configData.reportOptions = $event"
            />

            <div v-if="priceListConfig.editing">
              <FormHorizontalRule />
              <FormSubmit label="Update" :submitting="priceListConfig.submitting" @cancelled="cancelPriceListConfigEditing" @submitted="submitPriceListConfigEditing"></FormSubmit>
            </div>
          </FormGroup>
        </div>
      </div>
    </template>
  </ContentBox>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import PriceListConfigEditor from '@/modules/pricing/components/priceListConfigEditor.vue'

import { PriceListConfigEntryTypes, PriceListConfigDisplayTypes } from '@/store/types'

export default {
  name: 'CustomerPriceListConfig',
  components: {
    PriceListConfigEditor
  },
  mixins: [form],
  data: () => {
    return {
      contactData: {},
      stockPriceGroupList: [],

      priceListConfig: {
        editorForm: {},
        editing: false,
        configData: {},
        submitting: false
      }
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      this.$apiService.pricingService.getStockPriceGroupList().then(response => {
        this.$data.stockPriceGroupList = response.data
      })
      this.$apiService.contactService.getContact(this.$route.params.customerId).then(response => {
        this.$data.contactData = response.data

        // Update the breadcrumbs
        this.$store.commit("page/setPageBreadcrumbs", [
          { title: 'Home', link: '/' },
          { title: 'Contacts', link: '/contacts' },
          { title: this.$data.contactData.name, link: `/contacts/${this.$route.params.customerId}` }
        ])

      })
      this.$apiService.pricingService.getCustomerPriceListConfig(this.$route.params.customerId).then(response => {
        this.$data.priceListConfig.configData = response.data
      })
    },
    cancelPriceListConfigEditing() {
      this.$data.priceListConfig.editorForm = { }
      this.$data.priceListConfig.editing = false

      // Reload data back to the current
      this.$apiService.pricingService.getCustomerPriceListConfig(this.$route.params.customerId).then(response => {
        this.$data.priceListConfig.configData = response.data
      })
    },
    submitPriceListConfigEditing() {
      this.$data.priceListConfig.submitting = true
      this.$data.priceListConfig.editorForm = { }

      var updateData = {
        configuration: this.$data.priceListConfig.configData.configList,
        priceGroupDisplay: _.get(this.$data.priceListConfig, 'configData.reportOptions.priceGroupDisplay.customerDisplay', PriceListConfigDisplayTypes.inherit),
        deliveryInfoDisplay: _.get(this.$data.priceListConfig, 'configData.reportOptions.deliveryInfoDisplay.customerDisplay', PriceListConfigDisplayTypes.inherit),
        reportNotes: _.get(this.$data.priceListConfig, 'configData.reportOptions.reportNotes.customerDisplay', ''),
        headingText: _.get(this.$data.priceListConfig, 'configData.reportOptions.headingText.customerDisplay', ''),
        footerText: _.get(this.$data.priceListConfig, 'configData.reportOptions.footerText.customerDisplay', ''),
        noteListTitle: _.get(this.$data.priceListConfig, 'configData.reportOptions.noteListTitle.customerDisplay', '')
      }

      // Convert customer display settings to just display for updating
      updateData.configuration = this.$data.priceListConfig.configData.configList.map(configItem => {
        if(configItem.settings) {
          configItem.settings = configItem.settings.map(setting => {
            var newSetting = _.clone(setting)
            newSetting.display = setting.customerDisplay
            delete newSetting.customerDisplay
            delete newSetting.globalDisplay

            return newSetting
          })
        }

        return configItem
      })

      
      // Send data to server
      this.$apiService.pricingService.updateCustomerPriceListConfig(this.$route.params.customerId, updateData).then(response => {
        this.$data.priceListConfig.configData = _.cloneDeep(response.data)
        this.$data.priceListConfig.editing = false
      })
      .catch(err => {
        this.$data.priceListConfig.editorForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.priceListConfig.submitting = false
      })
    }
  }
}
</script>